import * as ProgressPrimitive from '@radix-ui/react-progress'
import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * Progress — determinate progress bar. Pencil X8FjS.
 */
export interface ProgressProps
  extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> {
  value?: number
  indeterminate?: boolean
  tone?: 'default' | 'success' | 'warning' | 'error'
}

const toneClass = {
  default: 'bg-primary',
  success: 'bg-ia-success',
  warning: 'bg-ia-warning',
  error: 'bg-ia-error',
} as const

export const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({ className, value = 0, indeterminate, tone = 'default', ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    value={indeterminate ? undefined : value}
    className={cn('relative h-2 w-full overflow-hidden rounded-pill bg-ia-elevated', className)}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={cn(
        'h-full transition-transform duration-300',
        toneClass[tone],
        indeterminate && 'animate-pulse',
      )}
      style={{ transform: indeterminate ? 'translateX(0)' : `translateX(-${100 - value}%)` }}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = 'Progress'
